(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };

  $.gnv.enableMobileMenu =  function (){

    $("#main-menu").mmenu({
      "offCanvas": {
        "position": "right"
      }
    }, {
      clone: true
    });

    var API       = $("#mm-main-menu").data( "mmenu" ),
        $userHelp = $(".b-user-helper__help a"),
        $userLang = $(".b-user-helper__langs a"),
        $userLogin = $(".b-user-helper__icon--logged a");

    $("#js-hamburger-button").click(function() {
       API.open();
    });

    // $userHelp.add($userLang) triggers the same method on two objects
	/*
    $userHelp.add($userLang).click(function() {
       API.close();
    });
	*/
   /* se il div non esiste da errore, è da controllare dato che non sono caricati sempre tutti i blocchi dell header */
   if($("#mm-main-menu").length > 0 )
   {
		if( typeof $userHelp !== 'undefined'){
		 $userHelp.click(function() {
			$('html,body').animate({scrollTop: 0});
			API.close();

		 });
		}
		if(typeof $userLang !== 'undefined'){
		 $userLang.click(function() {
			$('html,body').animate({scrollTop: 0});
			API.close();
		 });
		}
    if(typeof $userLogin !== 'undefined'){
     $userLogin.click(function() {
      $('html,body').animate({scrollTop: 0});
      API.close();
     });
    }
	}
  };
})(jQuery);
